import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Layout from "../../Layout";
import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Paper } from "@material-ui/core";
import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import googleAnalytics from "fuction/googleAnalytics";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1),
  },
}));

export default function LimitRelease(props) {
  const classes = useStyles();
  const { request } = useApi();
  const auth = useAuth();

  const now = dayjs(); // 現在の日付情報を取得
  const [page, setPage] = React.useState(1);
  const [maxTweets, setMaxTweets] = React.useState(0);
  const [maxExpanded, setMaxExpanded] = React.useState(0);
  const [releasedAt, setReleasedAt] = React.useState("");

  const limitRelease = () => {
    request({
      method: "POST",
      url: `config/:account_id/limit_release`,
    }).then((data) => {
      setPage(3);
    });
  };

  // フィルタホース情報取得
  const rquestFilterhorse = () => {
    if (!auth.state.user.account_id) {
      return;
    }

    request({
      method: "POST",
      url: `config/:account_id/account`,
      data: {
        "attrs": [
          "max_tweets",
          "max_expanded",
          "released_at",
        ]        
      },
    }).then((filterhorse) => {
      setMaxTweets(filterhorse.data.max_tweets);
      setMaxExpanded(filterhorse.data.max_expanded);
      setReleasedAt(filterhorse.data.released_at);
    });
  }
  
  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - プラン増量承諾";

    rquestFilterhorse();
  }, [auth.state.user.account_id]);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  return (
    <Layout
      content={
        <Grid>
          <Grid item>
            <Typography variant="h6" component="h6">
              プラン増量承諾画面
            </Typography>
          </Grid>
          <Paper className={classes.paper}>
            {page === 1 && (
              dayjs(releasedAt).isSame(now, 'M') ? (
                <div>
                  <p>
                    当月分の月間取得可能投稿件数増量オプションを既にご利用中です。
                    <br />
                    月間取得可能投稿件数増量オプションは月1回のみご利用頂けます。
                    <br />
                  </p>
                  <Link 
                    to="/dashboard"
                    style={{ textDecoration: 'none' }}
                  >
                    <Button
                      color="primary"
                    >
                      ホームへ戻る
                    </Button>
                  </Link>
                </div>
              ) : (
                <div>
                  <p>
                    月間取得可能投稿件数増量オプションをご利用頂くと、当月においてのみご契約プランの上限を超え、上位プランの月間取得可能投稿件数{maxExpanded}件まで投稿を取得いただけます。
                    <br />
                    現在の月間取得可能投稿件数：{maxTweets}件まで
                    <br />
                    増量オプションご利用後の月間取得可能投稿件数：{maxExpanded}件まで
                    <br />
                    ※翌月には、ご契約プランの件数の上限{maxTweets}件となります。
                    <br />
                    <br />
                    ご利用される方は次へお進みください
                  </p>
                  <Link 
                    to="/dashboard"
                    style={{ textDecoration: 'none' }}
                  >
                    <Button
                      color="primary"
                    >
                      ホームへ戻る
                    </Button>
                  </Link>
                  <Button
                    color="primary"
                    onClick={() => {
                      setPage(2);
                    }}
                  >
                    次へ
                  </Button>
                </div>
              )
            )}
            {page === 2 && (
              <div>
                <p>
                  月間取得可能投稿件数増量オプションの利用を行います。
                  <br />
                  <br />
                  増量オプションご利用後の月間取得可能投稿件数
                  <br />
                  {maxExpanded}件まで
                  <br />
                  <br />
                  本ご利用は取消することができませんのでご了承ください。
                  <br />
                </p>
                <Button
                  color="primary"
                  onClick={() => {
                    setPage(1);
                  }}
                >
                  前のページへ戻る
                </Button>
                <Button
                  color="primary"
                  onClick={limitRelease}
                >
                  了承の上利用する
                </Button>
              </div>
            )}
            {page === 3 && (
              <div>
                <p>
                  月間取得可能投稿件数増量オプションのご利用を承りました。
                  <br />
                  <br />
                  月間取得可能投稿件数
                  <br />
                  {maxExpanded}件まで
                  <br />
                  <br />
                  ご登録メールアドレスにも通知メールを送信致します。
                  <br />
                </p>
                <Link 
                  to="/dashboard"
                  style={{ textDecoration: 'none' }}
                >
                  <Button
                    color="primary"
                  >
                    ホームへ戻る
                  </Button>
                </Link>
              </div>
            )}
          </Paper>
        </Grid>
      }
    />
  );
}
